module.exports = __webpack_public_path__ + "static/img/theme_1.8ead5b50.png";